import { isPublicPath } from '@/src/utils/publicPaths'

// The admin areas an Essentials tenant's sidebar offers, plus the pages those
// areas link into. Their permission payload omits the other modules' rows
// entirely, and the per-page guards only fire on a row that exists but is
// unreadable, so without this any other admin URL still renders.
const ESSENTIALS_ROUTE_PREFIXES = [
  '/manage-content',
  '/create-content/content',
  '/broadcast-email',
  '/manage-investors',
  '/tags',
  '/segments',
  '/settings',
  '/manage-role',
  '/my-profile'
]

export interface AdminRouteContext {
  pathname: string
  isLoggedIn: boolean
  themeLoading: boolean
  tierResolved: boolean
  isEssentials: boolean
  profileLoading: boolean
  profileId: string | number
  userType: string
}

/**
 * 'loading': withhold the page. Until /theme and the profile first answer, an
 * Essentials user is indistinguishable from anyone else. Refetches keep the
 * previous answer, so a page is never unmounted mid-session, and a failed
 * request falls through permissively as useTier does; the backend's
 * check_permission still gates every call.
 * 'blocked': withhold the page and redirect to Investor Content.
 */
export const adminRouteAccess = (ctx: AdminRouteContext): 'loading' | 'blocked' | 'allowed' => {
  if (!ctx.isLoggedIn || isPublicPath(ctx.pathname)) return 'allowed'
  if ((ctx.themeLoading && !ctx.tierResolved) || (ctx.profileLoading && !ctx.profileId)) {
    return 'loading'
  }
  const isEssentialsStaff =
    ctx.isEssentials && (ctx.userType === 'business' || ctx.userType === 'sub_admin')
  const isOffered = ESSENTIALS_ROUTE_PREFIXES.some(
    p => ctx.pathname === p || ctx.pathname.startsWith(p + '/')
  )
  return isEssentialsStaff && !isOffered ? 'blocked' : 'allowed'
}
